<template>
  <div class="addApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">

      <!--<div class="add" @click="addp"><img src="~assets/images/ppp.png" /></div>-->
    
    <div class="title">
      <input type="text" v-model="title" placeholder="请输入作文标题" />
    </div>
    <div class="cons">
      <quill-editor v-model="content" :options="editorOption" ref="content"></quill-editor>

    </div>
    <div class="btn" @click="getQquey" style="left:7% !important;background:#ff3333">
      <img src="~assets/images/creation.png" />
      拍手写识别
    </div>
    <div class="btn" style="right:7% !important" @click="save">
      <img src="~assets/images/rl.png" />
      保存并发布
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  import { quillEditor, Quill } from 'vue-quill-editor'
  const toolbarOptions = [
    [{'align': []}],
  ]
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        imageUrl: '',
        avatar:'',
        title:'',
        content:'',
        img:[],
        editorOption: {
          placeholder: '请输入内容',
          modules: {
            toolbar: {
            }
          }
        }
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getUser();
    },
    components: {
      'quill-editor': quillEditor
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      save:function(){
        var that = this;
        var s_id = that.$route.query.id;
        var user_id = that.userData.id;
        if(that.title == ''){
          alert('请填写创作标题');
          return false;
        }
        if(that.content == ''){
          alert('请填写创作文章内容');
          return false;
        }
        that.fullscreenLoading = true;
        that.axios({
          'url': this.$host+'home/study/save',
          'method': 'post',
          params:{
            s_id:s_id,
            user_id:user_id,
            title:that.title,
            content:that.content,
            img:JSON.stringify(that.img)
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data;
          alert(res.message);
          if(res.status == 200){
            that.$router.go(-1);
          }

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                              that.getAjax(res.localData.replace('data:image/jpg;base64,',''))
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/study/handwriting',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.img.push(msg.data.img);
              $.each(msg.data.rs, function (i, item) {
                if(i == 0){
                  that.title = item.words
                }
                that.content += item.words;
              })
            }else{
              alert('识别失败！');
            }
            that.fullscreenLoading = false;
          }
        })
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .addApp{
    max-width:640px;
    background:#f1f1f1;
    margin:0 auto;
    position:relative;
  }
  .addApp .title{
    padding-top:2%;
    width:96%;
    margin:0 auto
  }
  .addApp .title input{
    width:94%;
    height:40px;
    border:none;
    border-radius:8px;
    padding:0 3%;
    margin-bottom:2%;
    outline:none;
    font-size:15px;
  }

  .addApp .btn{
    background:#007aff;
    width:40%;
    height:40px;
    border-radius:40px;
    text-align:center;
    color:#fff;
    font-size:15px;
    line-height:40px;
    position:absolute;
    bottom:40px;
  }
  .addApp .btn img{
    width:25px;
    display:inline-block;
    vertical-align:top;
    position:relative;
    top:7px
  }

  .addApp .ql-container{
    position:absolute;
    height:68%;
    background:#fff;
    width:96%;
    border:none;
    border-bottom-left-radius:8px;
    border-bottom-right-radius:8px;
    left:2%
  }
  .addApp .ql-toolbar{
    border:none;
    background:#fff;
    width:96%;
    border-bottom:1px #f1f1f1 solid;
    border-top-left-radius:8px;
    border-top-right-radius:8px;
    margin-left:2%;
  }

  .addApp .add{
    position:absolute;
    top:64px;
    right:20px;
    z-index:99;
    color:#007ae6;
    font-size:14px;
    font-weight:bold
  }
  .addApp .add img{
    width:22px
  }
  
</style>